
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from '@mui/x-data-grid';
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Button from "@mui/material/Button";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Tooltip
} from "@mui/material";

// App Imports

import {deleteContractSectionFilter, getAllContractSectionFilters} from "./ContractSectionFilterClient";
import {changeContractSectionFilter} from "../ContractSectionFilter/contractSectionFilterSlice";
import ContractSectionMenu from "../Menus/ContractSectionMenu";
import ContractSectionFilterDrawer from "../ContractSectionFilter/ContractSectionFilterDrawer";
import CustomFooter from "../CommonComponents/GridCustomFooter";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";
import CrudSnackbar from "../CommonComponents/CrudSnackbar";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

// main function
export default function ContractSectionFilterGrid() {

    // ****************** BEGIN STATES ****************************

    const [contractSectionFilters, setContractSectionFilters] = useState([]);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [contractSectionFilterDrawerMode, setContractSectionFilterDrawerMode] = React.useState([]);
    const [contractSectionFilterDrawerState, setContractSectionFilterDrawerState] = React.useState(false);
    const [configsVisible, setConfigsVisible] = React.useState(false);
    const [gridVisible, setGridVisible] = React.useState(true);
    const [searchVisible, setSearchVisible] = React.useState(false);
    const [showControls, setShowControls] = useState(true);
    const [showCRUD, setShowCRUD] = useState(true);


    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorContractSectionFilterId = useSelector((state) => state.contractSectionFilterSlc.value.id);

    const dispatchData = useDispatch();

    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************

    const fetchContractSectionFilters = () =>
        getAllContractSectionFilters()
            .then(res => res.content)
            .then(content => {
                console.log(content);
                setContractSectionFilters(content);
            })
    useEffect(() => {
        fetchContractSectionFilters();
    }, []);

    // ****************** END FETCH ****************************


    const renderContractSectionFilters = contractSectionFilters => {
        if (contractSectionFilters.length <= 0) {
            return "No Data";
        }}

    function handleControls(){
        setShowControls(!showControls)
    }


    useEffect(() => {
        fetchContractSectionFilters();
        dispatchData(changeContractSectionFilter({csfGridRefresh: false}));
    }, [useSelector((state) => state.contractSectionFilterSlc.value.csfGridRefresh)===true]);

    // ****************** BEGIN CRUD ***********************************

    const handleAdd = () => {
        dispatchData(changeContractSectionFilter({id: 0, contractSectionId: "",
            parentFilter: 0, previousFilter: 0, ordinalNumber: "", recordLevel: "",
            accessType: "", filteringMethod: "", dataPointId: "", singleValue: "",
            mockValue: "", fromValue: "", toValue: "",
            status: "", hierarchy: "",
            createdOn: "", createdBy: "", lastModifiedOn: "", lastModifiedBy: "",
            parentAccessType: "", parentFilteringMethod: "", parentDataPointName: "",
            parentMockValue: "", parentFromValue: "", parentToValue: "",
            previousAccessType: "", previousFilteringMethod: "", previousDataPointName: "",
            previousMockValue: "", previousFromValue: "", previousToValue: "",
        csfDrawerState: true, csfDrawerMode: "Add"}));
    };

    const handleEdit = (rowFull) => {
        dispatchData(changeContractSectionFilter({id: rowFull.id, contractSectionId: rowFull.contractSectionId,
            parentFilter: rowFull.parentFilter, previousFilter: rowFull.previousFilter, ordinalNumber: rowFull.ordinalNumber, recordLevel: rowFull.recordLevel,
            accessType: rowFull.accessType, filteringMethod: rowFull.filteringMethod, dataPointId: rowFull.dataPointId, singleValue: rowFull.singleValue,
            mockValue: rowFull.mockValue, fromValue: rowFull.fromValue, toValue: rowFull.toValue,
            status: rowFull.status, hierarchy: rowFull.hierarchy,
            createdOn: rowFull.createdOn, createdBy: rowFull.createdBy, lastModifiedOn: rowFull.lastModifiedOn, lastModifiedBy: rowFull.lastModifiedBy,
        csfDrawerState: true, csfDrawerMode: "Edit",
            parentAccessType: rowFull.parentAccessType, parentFilteringMethod: rowFull.parentFilteringMethod, parentDataPointName: rowFull.parentDataPointName,
        parentMockValue: rowFull.parentMockValue, parentFromValue: rowFull.parentFromValue, parentToValue: rowFull.parentToValue,
            previousAccessType: rowFull.previousAccessType, previousFilteringMethod: rowFull.previousFilteringMethod, previousDataPointName: rowFull.previousDataPointName,
            previousMockValue: rowFull.previousMockValue, previousFromValue: rowFull.previousFromValue, previousToValue: rowFull.previousToValue
        }));
        console.log("Here's the selected row data");
        console.log(rowFull);
    }

    const removeContractSectionFilter = (selectorContractSectionFilterId, callback) => {
        deleteContractSectionFilter(selectorContractSectionFilterId).then(() => {
            setDeleteOpen(false);
            callback(fetchContractSectionFilters);
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        })
    }

    const handleDeleteOpen = (selectContractSectionFilterId, selectContractSectionFilterMcode, selectContractSectionFilterName, selectContractSectionFilterDescription, rowFull) => {
        console.log("Here's the selected row data");
        console.log(rowFull);
        dispatchData(changeContractSectionFilter({id: selectContractSectionFilterId }));
        setDeleteOpen(true);
    };

    const handleDeleteClose = () => {
        setDeleteOpen(false);
    };

    const handleDeleteCancel = () => {
        setDeleteOpen(false);
    };

    // ****************** END CRUD ***********************************



    // ****************** BEGIN DRILLDOWN ****************************

    const handleDrilldown = (selectContractSectionFilterId,selectContractSectionFilterMcode, selectContractSectionFilterName, selectContractSectionFilterDescription, rowFull) => {
        console.log("Here's the selected row data");
        console.log(rowFull);
        dispatchData(changeContractSectionFilter({id: selectContractSectionFilterId, mcode: selectContractSectionFilterMcode, name: selectContractSectionFilterName, description: selectContractSectionFilterDescription }));
    }

    // ****************** END DRILLDOWN ****************************


    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>
                    <Tooltip title={"Add Contract"}>
                        <AddCircleOutlineIcon
                            sx={{mr: 3, mb: .5, verticalAlign: 'bottom'}}
                            fontSize="medium" color={'primary'}
                            onClick={() => handleAdd()}/>
                    </Tooltip>
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton sx={{mr: 3}} />
                    <GridToolbarDensitySelector />

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

    // ****************** END TOOLBAR ****************************


    // ****************** BEGIN COLUMNS ****************************

    const columns = fetchContractSectionFilters => [
        {
            field: "more",
            headerName: '',
            width: 30,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            hide: false,
            renderCell: (contractSectionFilters) => {
                return (
                    <div>
                    <Tooltip   enterDelay={1000}  title={'Action Menu'}>
                    <MoreHorizIcon fontSize={'small'} onClick= {() => handleControls()}/>
                    </Tooltip>
                    </div>
                );
            }

        },
        {
            field: "contractSectionFilterEdit",
            headerName: '',
            onCellClick: {},
            width: 20,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            hide: showControls,
            renderCell: (contractSectionFilters) => {
                return (
                    <IconButton
                        size="small"
                        variant="contained"
                        color="primary"
                    >
                        <EditIcon fontSize={'small'}  onClick= {() => handleEdit(contractSectionFilters.row)}/>
                    </IconButton>
                );
            }
        },
        {
            field: "contractSectionFilterDelete",
            headerName: '',
            width: 20,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            hide: showControls,
            renderCell: (contractSectionFilters) =>
                // {
                // return (
                <IconButton
                    size="small"
                    variant="contained"
                    color="primary"
                >
                    <DeleteOutlineIcon fontSize={'small'} onClick= {() => handleDeleteOpen(contractSectionFilters.row.id, contractSectionFilters.row.mcode,  contractSectionFilters.row.name, contractSectionFilters.row.description, contractSectionFilters.row)}/>
                    <Dialog
                        open={deleteOpen}
                        onClose={handleDeleteClose}
                        aria-labelledby="alert-delete-dialog-title"
                        aria-describedby="alert-delete-dialog-description"
                    >
                        <DialogTitle id="alert-delete-dialog-title">
                            {"Delete Confirmation"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-delete-dialog-description">
                                You are about to delete contractSectionFilter {selectorContractSectionFilterId}.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleDeleteCancel}>Cancel</Button>
                            <Button onClick={() => removeContractSectionFilter(selectorContractSectionFilterId, fetchContractSectionFilters)} autoFocus>
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>
                </IconButton>
        },
        {
            field: "up",
            headerName: '',
            width: 20,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            hide: showControls,
            renderCell: (drilldownCS) => {
                return (
                    <IconButton
                        size="small"
                        variant="contained"
                        color="primary"
                    >
                        <ArrowDropUpIcon/>
                    </IconButton>
                )
            }
        },
        {
            field: "down",
            headerName: '',
            width: 20,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            hide: showControls,
            renderCell: (drilldownCS) => {
                return (
                    <IconButton
                        size="small"
                        variant="contained"
                        color="primary"
                    >
                        <ArrowDropDownIcon/>
                    </IconButton>
                );
            }
        },
        {
            field: "left",
            headerName: '',
            width: 20,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            hide: showControls,
            renderCell: (drilldownCS) => {
                return (
                    <IconButton
                        size="small"
                        variant="contained"
                        color="primary"
                    >
                        <ArrowLeftIcon/>
                    </IconButton>
                );
            }
        },
        {
            field: "right",
            headerName: '',
            width: 20,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            hide: showControls,
            renderCell: (drilldownCS) => {
                return (
                    <IconButton
                        size="small"
                        variant="contained"
                        color="primary"
                    >
                        <ArrowRightIcon/>
                    </IconButton>
                );
            }
        },
        {    field: 'id',
            headerName: 'ID',
            description: '',
            sortable: true,
            width: 60,
            hide: true,
        },
        {
            field: 'contractSectionId',
            headerName: 'CS ID',
            description: '',
            sortable: false,
            editable: true,
            width: 60,
            renderCell: (contractSectionFilters) => {
                return <div className="rowitem">{contractSectionFilters.row.contractSection.id}</div>;},
            },
        {
        field: 'contractSectionName',
            headerName: 'Section',
        description: '',
        sortable: false,
        editable: true,
        width: 450,
        renderCell: (contractSectionFilters) => {
        return <div className="rowitem">{contractSectionFilters.row.contractSection.name}</div>;},
    },
        {
            field: 'parentFilterId',
            headerName: 'Parent',
            description: '',
            sortable: false,
            editable: true,
            width: 60,
        },
        {
            field: 'previousFilterId',
            headerName: 'Previous',
            description: '',
            sortable: false,
            editable: true,
            width: 60,
        },
        {
            field: 'ordinalNumber',
            headerName: 'Order',
            description: '',
            sortable: false,
            editable: true,
            width: 60,
        },
        {
            field: 'recordLevel',
            headerName: 'Level',
            description: '',
            sortable: false,
            editable: true,
            width: 60,
        },
        {
            field: 'accessType',
            headerName: 'Access',
            description: '',
            sortable: false,
            editable: true,
            width: 70,
        },
        {
            field: 'filteringMethod',
            headerName: 'Method',
            description: '',
            sortable: false,
            editable: true,
            width: 120,
        },
        {
            field: 'dataPointId',
            headerName: 'DP ID',
            description: '',
            sortable: false,
            renderCell: (contractSectionFilters) => {
                return <div className="rowitem">{contractSectionFilters.row.dataPoint.id}</div>;},
            width: 60,
        },
        {
            field: 'dataPointName',
            headerName: 'Data Point',
            description: '',
            sortable: false,
            renderCell: (contractSectionFilters) => {
                return <div className="rowitem">{contractSectionFilters.row.dataPoint.name}</div>;},
            width: 300,
        },
        {
            field: 'dataPointValueId',
            headerName: 'DPV ID',
            description: '',
            // renderCell: (contractSectionFilters) => {
            //     return <div className="rowitem">{contractSectionFilters.row.dataPointValue.id}</div>;},
            renderCell: (filteredCSF) => {
                if
                (
                    (filteredCSF.row.dataPointValue != null)
                    &&
                    (filteredCSF.row.dataPoint.dataType === "CODE")
                ) {
                    return <div className="rowitem3">{filteredCSF.row.dataPointValue.id}</div>;
                } else if (
                    (filteredCSF.row.dataPointValue != null)
                    &&
                    (filteredCSF.row.dataPoint.dataType === "YES_NO")
                ) {
                    return <div className="rowitem3">{filteredCSF.row.dataPointValue.id}</div>;
                } else if (
                    (filteredCSF.row.dataPointValue != null)
                    &&
                    (filteredCSF.row.dataPoint.dataType === "REFERENCE")
                ) {
                    return <div className="rowitem3">{filteredCSF.row.dataPointValue.id}</div>;
                }
            },
            width: 50,
        },
        {
            field: 'singleValue',
            headerName: 'Single Value',
            description: '',
            renderCell: (filteredCSF) => {if
            (
                (filteredCSF.row.dataPointValue != null)
                &&
                (filteredCSF.row.dataPoint.dataType === "CODE")
            )
            {return <div className="rowitem3">{filteredCSF.row.dataPointValue.name}</div>;}
            else if   (
                (filteredCSF.row.dataPointValue != null)
                &&
                (filteredCSF.row.dataPoint.dataType === "YES_NO")
            )
            {return <div className="rowitem3">{filteredCSF.row.dataPointValue.name}</div>;}
            else if   (
                (filteredCSF.row.dataPointValue != null)
                &&
                (filteredCSF.row.dataPoint.dataType === "REFERENCE")
            )
            {return <div className="rowitem3">{filteredCSF.row.dataPointValue.name}</div>;}
            else{return <div className="rowitem3">{filteredCSF.row.singleValue}</div>;}},
            width: 300,
            hide: true
        },
        {
            field: 'mockValue',
            headerName: 'Single Value',
            description: '',
            width: 300,
        },
        {
            field: 'fromValue',
            headerName: 'From Value',
            description: '',
            width: 100,
        },
        {
            field: 'toValue',
            headerName: 'To Value',
            description: '',
            width: 100,
        },
        {
            field: 'status',
            headerName: 'Status',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'hierarchy',
            headerName: 'Hierarchy',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'createdOn',
            headerName: 'createdOn',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'createdBy',
            headerName: 'createdBy',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'lastModifiedOn',
            headerName: 'lastModifiedOn',
            description: '',
            width: 100,
            hide: true
        },
        {
            field: 'lastModifiedBy',
            headerName: 'lastModifiedBy',
            description: '',
            width: 100,
            hide: true},
        {    field: 'parentAccessType',hide: true},
        {    field: 'parentFilteringMethod',hide: true},
        {    field: 'parentDataPointName',hide: true},
        {    field: 'parentMockValue',hide: true},
        {    field: 'parentFromValue',hide: true},
        {    field: 'parentToValue',hide: true},
        {    field: 'previousAccessType',hide: true},
        {    field: 'previousFilteringMethod',hide: true},
        {    field: 'previousDataPointName',hide: true},
        {    field: 'previousMockValue',hide: true},
        {    field: 'previousFromValue',hide: true},
        {    field: 'previousToValue',hide: true},
    ];

    // ****************** END COLUMNS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: '100%' }}>
            {showCRUD && <ContractSectionMenu/>}
            {useSelector((state) => state.contractSectionFilterSlc.value.csfDrawerState) &&
            <ContractSectionFilterDrawer
                fetchContractSectionFilters = {fetchContractSectionFilters}
            />}
            {gridVisible && <DataGrid
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                aria-label={"ContractSectionFilters"}
                rows={contractSectionFilters}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={columns(fetchContractSectionFilters)}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={contractSectionFilter => contractSectionFilter.id}
                components={{
                    Toolbar: CustomToolbar,
                    Footer: CustomFooter,
                }}
            />}
            <CrudSnackbar/>
        </div>

    );

    // ****************** END RETURN ****************************

}



